import { isClientSide } from 'src/utils/constants';

import {
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_ENV_VARIANT,
  getEnvVariable
} from 'src/utils/envVariablesHelper';
import logger from 'src/utils/logger';

declare global {
  interface Window {
    gtag: (
      event: string,
      eventName: string,
      // eslint-disable-next-line
      eventConfig?: any) => void;
  }
}

export enum GTAGPrefix {
  default = 'default',
  likie = 'likie',
  top = 'top',
  watched = 'watched',
  sameeffect = 'sameeffect',
  otherforms = 'otherforms',
  fullanalog = 'fullanalog',
  otherpopular = 'other_popular',
  header = 'header',
  footer = 'footer',
  menu = 'menu',
  tradename = 'tradename',
  catalog = 'catalog',
  subcategory = 'subcategory',
  catalogdropdownsubcategory = 'catalog_dropdown_subcategory',
  cart = 'cart',
  cartitem = 'cart_item',
  cartorder = 'cart_order',
  cartorderitem = 'cart_order_item',
  addtoorder = 'addtoorder',
  minicart = 'minicart',
  speedsearch = 'speedsearch',
  speedsearchresult = 'speedsearch_result',
  item = 'item',
  profile = 'profile',
  city = 'city',
  citymodal = 'city_modal',
  login = 'login',
  registration = 'registration',
  blog = 'blog',
  widget = 'widget',
  aboutus = 'about_us'
}

export enum GTAGFilterPrefix {
  'uaTexts.maker' = 'company',
  'uaTexts.form' = 'form',
  'quantityInPackString' = 'quantity',
  'doze' = 'dosage',
  'uaTexts.component' = 'substance',
  'forAllergic.text' = 'allergic',
  'forPregnant.text' = 'pregnant',
  'forChildren.text' = 'kids',
  'forDiabetic.text' = 'diabetics',
  'forMothers.text' = 'mothers',
  'forDrivers.text' = 'drivers',
  'withAlcohol.text' = 'alco',
  'withRecipe.text' = 'recipe'
}

const useGTAG = () => {
  const currentEnv = getEnvVariable(NEXT_PUBLIC_ENV);
  const trackingEnabled = currentEnv === NEXT_PUBLIC_ENV_VARIANT.PROD;

  const trackGtagEvent = (
    eventName: string,
    eventParams?: string | string[],
    paramName = 'item_name'
  ) => {
    try {
      if (isClientSide) {
        const gtagAvailable = trackingEnabled && 'gtag' in window;
        logger.log('%c===== GTAG event =====', 'color: red; font-size: 12px');
        if (eventParams && gtagAvailable) {
          window.gtag('event', eventName, {
            [paramName]: eventParams
          });
        } else if (gtagAvailable) {
          window.gtag('event', eventName);
        } else {
          logger.log('event', eventName, {
            [paramName]: eventParams
          });
        }
      } else {
        logger.error('GTAG cannot be called from server');
      }
    } catch (error) {
      logger.error('GTAG ERROR', error);
    }
  };

  const trackCustomGtagEvent = (
    eventName: string,
    eventConfig: { [key: string]: string }
  ) => {
    try {
      if (trackingEnabled && 'gtag' in window) {
        window.gtag('event', eventName, eventConfig);
      } else {
        logger.log('event', eventName, eventConfig);
      }
    } catch (error) {
      logger.error('GTAG ERROR', error);
    }
  };

  return { trackGtagEvent, trackCustomGtagEvent };
};

export default useGTAG;
